import React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface EmptyStateCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonLabel: string;
  onAction: () => void;
  compact?: boolean;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({ icon, title, description, buttonLabel, onAction, compact }) => (
  <Paper
    sx={{
      p: compact ? 2.5 : 4,
      textAlign: 'center',
      border: '1px dashed',
      borderColor: 'grey.300',
      bgcolor: 'background.default',
      boxShadow: 'none'
    }}
  >
    {React.isValidElement(icon) &&
      React.cloneElement(icon as React.ReactElement<{ sx?: object }>, {
        sx: { fontSize: compact ? 28 : 40, color: 'text.secondary', mb: 1 }
      })}
    <Typography variant={compact ? 'body2' : 'body1'} color="text.secondary" gutterBottom>
      {title}
    </Typography>
    <Typography variant={compact ? 'caption' : 'body2'} color="text.secondary" sx={{ mb: 2 }} component="p">
      {description}
    </Typography>
    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={onAction}
      size={compact ? 'small' : 'medium'}
    >
      {buttonLabel}
    </Button>
  </Paper>
);

export default EmptyStateCard;
